export const BotonProcesosPGI = (props) =>{
    let infoProcesos = props.procesos.map( data =>({
        ...data,
        nroOrden: data.nroOrden.split(',').map(Number)
    }))

    const estiloFinalizado = ' bg-blue-600 text-white procesoFinalizado border-blue-800';
    const estiloPendiente = ' bg-gray-500 text-white procesoPendiente ';
    
    return(
        <>
            <div
                className="flex gap-[1px] justify-center"
                // key={'divContenedorProcesoBtn_' }// + dataIncidencia.fechaInicioProgramado
                key={'divContenedorProcesoBtn_' + props.informacion.codIncidencia}// + dataIncidencia.fechaInicioProgramado
            >
                {
                    infoProcesos.map((p, index) => (
                        <div key={index + '_' + props.informacion.codIncidencia}> 
                        
                            <button
                                // {...props}
                                className={` min-w-[20px] max-w-[40px] rounded disabled:cursor-not-allowed
                                    ${(props.codEstado === 50 || props.codEstado === 48) && p.nroOrden.every( nro => nro > props.numeroProceso) ? ' opacity-30 ' : ' cursor-pointer '}
                                    ${props.codEstado === 50 ?  estiloPendiente : (p.nroOrden.some( nro => nro < props.numeroProceso) ? estiloFinalizado : estiloPendiente) }
                                `}
                                disabled={p.nroOrden.some( nro => nro <= props.numeroProceso ) ? false : true}
                                key={index + '_' + props.informacion.codIncidenciaEmpresa}
                                onClick={async (e) => {
                                    if(p.nroOrden.some( nro => props.numeroProceso >= nro)){
                                        props.functionEjecutar && await props.functionEjecutar()
                                        props.setNumeroProceso(props.numeroProceso)
                                        props.setProcesoElegido(Math.min(...p.nroOrden))
                                        props.openModal();  
                                    }
                                    else{
                                        e.preventDefault()
                                    }
                                }}
                            >
                                <span>{index + 1 }</span>
                                {
                                    props.enProceso &&  index === 2 ? 
                                        <i className="fa fa-spinner text-xs top-0 font-bold absolute animate-spin "></i>
                                    :
                                        <></>
                                }
                            </button>
                            {/* <Tooltip type={'dark'} id={p.numeroEstado + p.nombre}>{p.nombre}</Tooltip> */}
                        </div>
                    ))
                }
            </div>
        </>
    )
}